import { injectable, Container } from 'inversify';
import { setup as appSetup } from 'src/app/main.config'
import { ConfigurationService } from 'src/core/services/configuration.service';
import { IdentityService } from 'src/core/services/identity.service';
import { HttpService } from 'src/core/services/http.service';
import { FormatService } from 'src/core/services/format.service';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ContextService } from 'src/core/services/context.service';
import { DataService } from 'src/core/services/data.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { EmailDocumentService } from 'src/app/general/email-document-template/email-document.service';
import { CommunicationService } from 'src/core/services/communication.service';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
// Initialize DI/IoC container
var container = new Container();

// Initialize services
container.bind(ConfigurationService).toSelf().inSingletonScope();
container.bind(CommunicationService).toSelf().inSingletonScope();
container.bind('ConfigurationService').to(ConfigurationService).inSingletonScope();
container.bind(IdentityService).toSelf().inSingletonScope();
container.bind(FormatService).toSelf().inSingletonScope();
container.bind(HttpService).toSelf();
container.bind(DataService).toSelf();
container.bind(ContextService).toSelf();
container.bind(DialogService).toSelf();
container.bind(ToastNotifications).toSelf();
container.bind(EmailDocumentService).toSelf();
container.bind(RulesReflectionService).toSelf();

// Initialize App services
appSetup(container);

export { container }



// WEBPACK FOOTER //
// ./src/inversify.config.ts